import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <header className="header">
      <div className="container">
        <div className="nav-brand">
          <Link to="/" className="logo">
            <div className="logo-container">
              <img src="/vwire.jpg" alt="Vardhaman Wire Logo" className="logo-image" />
              <div className="logo-text">
                <h1>🌟 VARDHAMAN WIRE 🌟</h1>
                <p>Reliable for Wire & Fencing Needs</p>
              </div>
            </div>
          </Link>
        </div>
        
        <button 
          className={`menu-toggle ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
          <ul className="nav-links">
            <li>
              <Link 
                to="/" 
                className={isActive('/') ? 'active' : ''}
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </Link>
            </li>
            <li>
              <Link 
                to="/about" 
                className={isActive('/about') ? 'active' : ''}
                onClick={() => setIsMenuOpen(false)}
              >
                About Us
              </Link>
            </li>
            <li>
              <Link 
                to="/products" 
                className={isActive('/products') ? 'active' : ''}
                onClick={() => setIsMenuOpen(false)}
              >
                Our Products
              </Link>
            </li>
          </ul>
          
          <div className="contact-info">
            <div className="phone">
              📞 <a href="tel:+919404257415">+91 9404257415</a>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;